export const topicsPath = {
  /* inject path */
  CHECK_RELATED_ITEMS: '/topics/check-related-items',
  ADD_NEW_CATEGORY: '/topics/add-new-category',
  EDIT_CATEGORY: '/topics/edit-category/:id',
  EDIT_CATEGORY_URI: '/topics/edit-category',
  SUBCATEGORY: '/topics/categories-table/:id/:name',
  SUBCATEGORY_URI: '/topics/categories-table',
  CATEGORIES_TABLE: '/topics/categories-table',
  ADD_NEW_TOPIC: '/topics/add-new-topic',
  EDIT_TOPIC: '/topics/edit-topic/:id',
  EDIT_TOPIC_URI: '/topics/edit-topic',
  TOPICS_DETAILS: '/topics/topics-details/:id',
  TOPICS_DETAILS_URI: '/topics/topics-details',
  TOPICS_TABLE: '/topics/topics-table',
  COMPARE_TOPICS: '/topics/compare-topics',
  DASHBOARD: '/topics/dashboard',
  TOP_COUNTRIES_WORLD_MAP: '/topics/top-countries-map',
};
